import { TCalendar, TCustomEvent } from "../models/wpbotModel"

const isNumericId = (value: unknown): boolean => /^\d+$/.test(String(value ?? "").trim())

/** Id SQL de calendars (FK de whatsapp_bots.calendar_id). */
export const calendarSqlId = (cal: TCalendar): string => {
  const candidates = [cal.id, cal.uid]
  const numeric = candidates.find((c) => isNumericId(c))
  return numeric != null ? String(numeric) : String(cal.uid || cal.id || "")
}

/** Doc id de Firestore (get/update-calendar). Nunca el id SQL numérico. */
export const calendarFirestoreUid = (cal: TCalendar): string => {
  const firestoreId = (cal as TCalendar & { firestore_id?: string }).firestore_id
  if (firestoreId && !isNumericId(firestoreId)) return String(firestoreId)
  if (cal.uid && !isNumericId(cal.uid)) return String(cal.uid)
  if (cal.id && !isNumericId(cal.id)) return String(cal.id)
  return ""
}

export const calendarLabel = (cal: TCalendar): string => {
  const name = String(cal.name || "").trim()
  return name || `Calendario ${calendarSqlId(cal)}`
}

export const findCalendar = (list: TCalendar[], value?: string | number | null): TCalendar | undefined => {
  const v = String(value ?? "").trim()
  if (!v) return undefined
  return list.find((cal) => {
    const fs = (cal as TCalendar & { firestore_id?: string }).firestore_id
    return (
      calendarFirestoreUid(cal) === v ||
      calendarSqlId(cal) === v ||
      String(cal.id) === v ||
      String(cal.uid) === v ||
      String(fs || "") === v
    )
  })
}

export const calendarServices = (cal?: TCalendar): TCustomEvent[] =>
  ((cal?.customEvents || cal?.custom_events || []) as TCustomEvent[])

export const newServiceId = () =>
  `ce-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`

export const sanitizeCustomEvents = (customEvents: TCustomEvent[] | undefined): TCustomEvent[] =>
  (customEvents || [])
    .map((ev) => ({
      id: ev.id || newServiceId(),
      name: (ev.name || "").trim(),
      duration: Number(ev.duration) || 30,
    }))
    .filter((ev) => ev.name)

export const calendarSelectOptions = (calendars: TCalendar[]) =>
  calendars.map((cal) => ({
    value: calendarFirestoreUid(cal) || calendarSqlId(cal),
    label: calendarLabel(cal),
  }))
